// extracted by css-extract-rspack-plugin
export default {"edit-btn":"EqHrIt","editBtn":"EqHrIt","disabled":"x4YMM9"};